import request from '@/utils/request'

// 获取省市区数据
export function getCityList() {
  return request({
    url: '/system/config/ssx',
    method: 'get',
  })
}

// 获取多个下拉框数据/data/type/{{dictType}}
export function dictType(dictType) {
  return request({
    url: '/data/type/'+dictType,
    method: 'get',
  })
}
// 下载附件 http://域名/attachment/zipDownload/{attachmentId}
export function downFile(attachmentId) {
  return request({
    url: '/attachment/zipDownload/'+attachmentId,
  })
}
// 任务包类型http://域名/data/type/projectPackage_type
export function packageType() {
  return request({
    url: '/data/type/projectPackage_type',
  })
}
//获取开普勒地址
export function keplerUrl() {
  return request({
    url: '/keplerJump',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js